import { Box, useMediaQuery } from '@mui/material'
import { FilterContext } from 'Components/Filter/context'
import { FilterControlsSlot } from 'Components/Filter/slots'
import { SearchContext } from 'Components/Layout/MainLayout/SearchContext'
import SearchTabs from 'Components/SearchComponents/SearchTabs'
import { useContext, useState } from 'react'
import { navigateToBack } from 'Scenes/navigators'
import { FA_ICONS } from 'Theme/font-awesome-icon-constants'
import { BREAKPOINT_MIN_MD } from 'Theme/stylesUtil'

import SearchField from '../../SearchField'
import { FiltersContainer } from './FiltersContainer'
import { HeaderButton } from './HeaderButton'
import { SwipableContainer } from './SwipableContainer'

export const MobileSearch = ({ contentType, setContentType, mapsTotal, prefabsTotal }) => {
  const { onSearch } = useContext(FilterContext)
  const { search } = useContext(SearchContext)

  const isBiggerThanMDScreen = useMediaQuery(BREAKPOINT_MIN_MD)
  const [isFiltersOpened, setIsFiltersOpened] = useState(false)

  const handleFiltersClick = () => {
    setIsFiltersOpened(!isFiltersOpened)
  }

  const handleClose = () => {
    setIsFiltersOpened(false)
  }

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-around"
        py={1}
      >
        <HeaderButton
          iconClassName={FA_ICONS.ARROW_LEFT}
          onClick={navigateToBack}
        />
        <SearchField
          value={search}
          onChange={onSearch}
          allowClear
          isMobile={!isBiggerThanMDScreen}
          style={{ backdropFilter: 'blur(20px)' }}
          placeholder="Enter title"
        />
        <HeaderButton
          iconClassName={FA_ICONS.OPTIONS}
          onClick={handleFiltersClick}
        />
        {isFiltersOpened && (
          <SwipableContainer
            isOpened
            onClose={handleClose}
          >
            <FiltersContainer
              handleClose={handleClose}
              type={contentType}
            />
          </SwipableContainer>
        )}
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        px={1}
      >
        <SearchTabs
          contentType={contentType}
          setContentType={setContentType}
          mapsTotal={mapsTotal}
          prefabsTotal={prefabsTotal}
        />
        <FilterControlsSlot />
      </Box>
    </>
  )
}
